<template>
   <!-- <v-card> -->
        <v-select
        :label="modelValue.title"
        :items="modelValue.options"
        :item-title="'title'"
        :item-value="'value'"
        :name="modelValue.name"
        :id="modelValue.id"
        :model-value="modelValue.value"
        @update:model-value="handleChange"
        :error-messages="modelValue.error"
        density="comfortable"
        :required="modelValue.mandatory"
        bg-color="white"
        >
        <template v-slot:append-inner v-if="modelValue.mandatory">
            <v-icon color="red" size="small">mdi-asterisk</v-icon>
        </template>
        </v-select>
    <!-- </v-card> -->
</template>

<script>
export default {
    name: 'SelectComponent',

    props: ['modelValue',], //modelValue - it the name of the prop that will be used for v-model binding (from parent component)
    emits: ['update:modelValue'],

    data() {
        return {
            
        };
    },

    mounted() {
        if (this.modelValue.value == null && this.modelValue.default != null) {
            this.handleChange(this.modelValue.default);
        }
    },

    methods: {
        handleChange(newValue) {
            this.$emit('update:modelValue', {
                ...this.modelValue,
                value: newValue,
                error: '', // Reset any previous error
            });
        }
    }

}
</script>

<style scoped>
/* :deep(.v-label) {
  text-align: right;
  width: 100%;
} */
</style>